import React, { useEffect, useState } from 'react';

// import { useNavigate } from 'react-router-dom';

import axios from "axios";
import toast from 'react-hot-toast';

import DataTable from "react-data-table-component";
import deleteIcon from "../../../assets/delete.svg";
import editIcon from "../../../assets/edit.svg";
import add from "../../../assets/plusWhite.svg";
import loadingGif from "../../../assets/loadingGif.gif";
import DeleteModal from '../../ReUseable/Modals/DeleteModal';
import { API } from '../../../global';

const WorkflowsList = (props) => {
  const { setShowCreateWorkflow } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [pipelines, setPipelines] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [loading, setLoading] = useState(false);
  // const navigate = useNavigate();

  useEffect(() => {
    getAllPipelines();
  }, [])

  const getAllPipelines = async () => {
    try {
      setLoading(true);
      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("auth_token")}`
        }
      };
      const response = await axios.get(`${API}/dashboard/all-pipelines`, config);
      setLoading(false);
      if (response.data.success) {
        setPipelines(response.data.result);
      } else {
        toast.error(response.data.error.msg);
      }
    } catch (error) {
      setLoading(false);
      toast.error("Error fetching pipelines");
    }
  }

  const handleDeletePipelines = async (row) => {
    console.log(row);
    try {     
      setDeleteModalOpen(false);
      getAllPipelines();
      toast.success("Pipeline deleted successfully");
    } catch (error) {
      console.log(error);
    }
  }

  // const handleDeleteModalOpen = (row) => {
  //   setDeleteModalOpen(true);
  //   setSelectedRow(row);
  // }

  console.log(pipelines, "pipelines");

  const calculateSerialNumber = (index) => {
    return (
      <div>
        {(currentPage - 1) * rowsPerPage + index + 1}
      </div>
    )
  };

  const pipelineNameColumn = (row) => {
    return (
      <div>
        {row.name}
      </div>
    )
  }

  const actionColumn = (row) => {
    return (
      <div className='gap-4 flex'>
        <img src={editIcon} alt="edit" className='cursor-pointer' />
        <img src={deleteIcon} alt="delete" className='cursor-pointer' />
      </div>
    )
  }

  const columns = [
    {
      name: "S.No",
      sortable: true,
      cell: (row, index) => calculateSerialNumber(index),
      width: "150px",
      center: true,
    },
    {
      name: "Name",
      sortable: true,
      cell: (row) => pipelineNameColumn(row),
      selector: (row) => row.name,
      width: "800px",
      // center: true,
    },

    {
      name: "Action",
      cell: (row) => actionColumn(row),
      // width: "200px",
      center: true,
    },
  ];

  const customStyles = {
    headRow: {
      style: {
        fontSize: "0.875rem",
        backgroundColor: "#F9FAFB",
        fontWeight: 600,
        fontFamily: "poppins",
        color: "#212529",
      },
    },
    rows: {
      style: {
        // textAlign: "center",
      },
    },
    cells: {
      style: {
        fontSize: "0.875rem",
        borderBottom: "1px solid #DDDEE0",
        fontFamily: "poppins",
        color: "#212529",
        fontWeight: 400,
      },
    },
  };

  const handleCreateWorkflow = () => {
    setShowCreateWorkflow(true);
  }

  return (
    <div className={`${deleteModalOpen ? 'overflow-hidden h-screen' : ''} `}>
      <div className='flex justify-between mt-16 px-5 ms-[50px]'>
        <div className='text-[#212529] text-[18px] font-medium'>Pipelines</div>
        <button className='bg-[#0078C5] px-3 py-1.5 rounded-md flex justify-center border-none items-center text-[#ffffff] gap-2 text-sm  font-normal' onClick={() => handleCreateWorkflow()}><img src={add} alt="add" />Create</button>
      </div>
      {loading ? (
        <div className="flex justify-center items-center mt-28 flex-col">
          <div className="flex flex-col justify-center items-center">
            <img src={loadingGif} alt="loading" className="w-[50px] h-[65px]" />
            <h5 className="mt-5">Loading....</h5>
          </div>
        </div>
      ) : (
        <div className='border border-[#DDDEE0] ms-[70px] me-5 mt-5 mb-10 rounded-t-lg font-medium text-[#212529]'>
          {pipelines?.length < 9 ? (
            <DataTable
              columns={columns.filter((column) => column !== null)}
              data={pipelines}
              customStyles={customStyles}
              defaultSortFieldId={2}
            />
          ) : (
            <DataTable
              columns={columns.filter((column) => column !== null)}
              data={pipelines}
              customStyles={customStyles}
              defaultSortFieldId={2}
              pagination
              paginationPerPage={rowsPerPage}
              paginationTotalRows={pipelines.length}
              paginationDefaultPage={currentPage}
              onChangePage={(page) => setCurrentPage(page)}
            />
          )}
        </div>
      )}
      {deleteModalOpen && (
        <DeleteModal
          setModalOpen={setDeleteModalOpen}
          modalOpen={deleteModalOpen}
          handleDelete={handleDeletePipelines}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
        />
      )
      }
    </div >
  )
}

export default WorkflowsList;